import 'select2/dist/js/select2.min'
import 'bootstrap';
import 'air-datepicker/src/js/air-datepicker';

export default {
  init() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);


    $('.select-customer').select2({
      minimumResultsForSearch: -1,
    });
    $('#select-type-point').select2({
      minimumResultsForSearch: -1,
      dropdownParent: $('#add-new-point-select'),
    });
    $('#select-type-geozone').select2({
      minimumResultsForSearch: -1,
      dropdownParent: $('#add-new-geozone-select'),
    });
    $('#select-report-name').select2({
      minimumResultsForSearch: -1,
      dropdownParent: $('.reports__inputs-box'),
    });
    $('#select-report-based').select2({
      minimumResultsForSearch: -1,
      dropdownParent: $('.reports__inputs-box'),
    });
    //header-notifications
    $('.header__bell').click(function () {
      $('.header__notifications-dropdown').toggleClass('header__dropdown-active');
    });
    $('.header__notifications-close a').click(function (e) {
      e.preventDefault();
      $('.header__notifications-dropdown').removeClass('header__dropdown-active');
    });

    $(function($){
      $(document).mouseup(function (e) {
        if($('.header__notifications-dropdown').hasClass('header__dropdown-active')) {
          var div = $('#header__notifications-click');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.header__notifications-dropdown').removeClass('header__dropdown-active');
          }
        }
      });
    });

    //header search
    $('.header__search a').click(function () {
      $('.header__search input').toggleClass('active');
      $('.header__logo').toggleClass('hidden-class');
    });

    $(function($){
      $(document).mouseup(function (e) {
        if($('.header__search input').hasClass('active')) {
          var div = $('#header__search');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.header__search input').removeClass('active');
            $('.header__logo').removeClass('hidden-class');
          }
        }
      });
    });

    //navi-buttons
    $('#drivers-button').click( function (e) {
      e.preventDefault();
      $('.modal-block').removeClass('z-index-2');
      $('.modal-block').not('.drivers').removeClass('active-modal active-modal-2');
      $('.drivers').toggleClass('active-modal');
      $(this).toggleClass('active-svg')
    });
    $('#geozones-button').click( function (e) {
      e.preventDefault();
      $('.modal-block').removeClass('z-index-2');
      $('.modal-block').not('.geozones').removeClass('active-modal active-modal-2');
      $('.geozones').toggleClass('active-modal');
      $(this).toggleClass('active-svg')
    });
    $('#fleet-status-button').click( function (e) {
      e.preventDefault();
      $('.modal-block').removeClass('z-index-2');
      $('.modal-block').not('.fleet-status').removeClass('active-modal active-modal-2');
      $('.fleet-status').toggleClass('active-modal');
      $(this).toggleClass('active-svg')
    });
    $('#events-button').click( function (e) {
      e.preventDefault();
      $('.modal-block').removeClass('z-index-2');
      $('.modal-block').not('.events').removeClass('active-modal active-modal-2');
      $('.events').toggleClass('active-modal');
      $(this).toggleClass('active-svg')
    });
    $('#create-route-button').click( function (e) {
      e.preventDefault();
      $('.modal-block').removeClass('z-index-2');
      $('.modal-block').not('.create-route').removeClass('active-modal active-modal-2');
      $('.create-route').toggleClass('active-modal');
      $(this).toggleClass('active-svg')
    });
    $('#dashboard-button').click( function (e) {
      e.preventDefault();
      $('.modal-block').removeClass('z-index-2');
      $('.modal-block').not('.dashboard').removeClass('active-modal active-modal-2');
      $('.dashboard').toggleClass('active-modal');
      $(this).toggleClass('active-svg')
    });
    $('#reports-button').click( function (e) {
      e.preventDefault();
      $('.modal-block').removeClass('z-index-2');
      $('.modal-block').not('.reports').removeClass('active-modal active-modal-2');
      $('.reports').toggleClass('active-modal');
      $(this).toggleClass('active-svg')
    });
    $('.menu__navi-position a').click( function (e) {
      e.preventDefault();
      $('.menu__navi a').not(this).removeClass('active-svg');
      $('.menu__navi').removeClass('mobile-active');
      $('.header__burger').toggleClass('burger-active');
    });

    $(function($){
      $(document).mouseup(function (e) {
        if ($('.menu__navi').hasClass('mobile-active')) {
          var div = $('#menu-navi-click');
          var burger = $('#header-burger')
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            if (!burger.is(e.target) && burger.has(e.target).length === 0) {
              $('.menu__navi').removeClass('mobile-active')
              $('.header__burger').toggleClass('burger-active');
            }
          }
        }
      });
    });
    //close
    $('.modal-close').click( function (e) {
      e.preventDefault();
      let thisElement = this;
      $(thisElement).parent().parent('.modal-block').removeClass('z-index-2');
      $(thisElement).closest('.modal-block').find('.modal-block-2').removeClass('z-index-2');
      setTimeout(function() {
        $(thisElement).closest('.modal-block').removeClass('active-modal');
        $(thisElement).closest('.modal-block').removeClass('active-modal-2');
        $(thisElement).closest('.modal-block').find('.modal-block-2').removeClass('active-modal-2');
        $('.menu__navi a').removeClass('active-svg')
      }, 150);
    });
    //close huck
    $('.modal-close-2').click( function (e) {
      e.preventDefault();
      let thisElement = this;
      $(thisElement).parent().parent('.modal-block').removeClass('z-index-2');
      $(thisElement).closest('.modal-block').find('.modal-block-2').removeClass('z-index-2');
      setTimeout(function() {
        $(thisElement).closest('.modal-block').removeClass('active-modal');
        $(thisElement).closest('.modal-block').removeClass('active-modal-2');
        $(thisElement).closest('.modal-block').find('.modal-block-2').removeClass('active-modal-2');
      }, 150);
    });

    //object details button
    $('.fleet-status__list-options .modal-content__list-item').click( function (e) {
      e.preventDefault();
      $('.object').addClass('active-modal-2');
      setTimeout(function() {
        $('.object').addClass('z-index-2');
      }, 300);
    });
    //events details button
    $('.events__list .modal-content__list-item').click( function (e) {
      e.preventDefault();
      $('.modal-block-2').removeClass('z-index-2');
      $('.events-details').addClass('active-modal-2');
      setTimeout(function() {
        $('.events-details').addClass('z-index-2');
      }, 300);
    });
    //add-drivers-button
    $('#add-drivers-button').click( function (e) {
      e.preventDefault();
      $('.add-new-drivers').addClass('active-modal-2');
      setTimeout(function() {
        $('.add-new-drivers').addClass('z-index-2');
      }, 300);
    });
    //geozones details button
    $('.geozones .modal-content__list-item').click( function (e) {
      e.preventDefault();
      $('.modal-block-2').removeClass('z-index-2');
      $('.geozones-details').addClass('active-modal-2');
      setTimeout(function() {
        $('.geozones-details').addClass('z-index-2');
      }, 300);
    });

    //add-geozone-button
    $('#add-geozones-button').click( function (e) {
      e.preventDefault();
      $('.modal-block-2').removeClass('z-index-2');
      $('.add-new-geozone').addClass('active-modal-2');
      setTimeout(function() {
        $('.add-new-geozone').addClass('z-index-2');
      }, 300);
    });

    //geozones create group button
    $('#create-zone-group-button').click( function (e) {
      e.preventDefault();
      $('.modal-block-2').removeClass('z-index-2');
      $('#create-zone-group-button').removeClass('button-active')
      $('.geozones-group').addClass('active-modal-2');
      setTimeout(function() {
        $('.geozones-group').addClass('z-index-2');
      }, 300);
    });

    //geozones select zones
    $('.geozones__select-current').click( function () {
      $('.geozones__select-dropdown').slideToggle();
      $('.geozones__select-current').toggleClass('chevron-rotate');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('.geozones__select-dropdown').css('display') == 'block') {
          var div = $('#geozones__select-click');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.geozones__select-dropdown').slideUp();
            $('.geozones__select-current').removeClass('chevron-rotate');
          }
        }
      });
    });
    $('.geozones__select-dropdown .accordion-input').on('click', function(){
      $('.accordion-input').not(this).prop('checked', false)
      let  geozonesContent = $(this).next().find('p').html();
      let  geozonesContent2 = $(this).next().find('span').html();
      $('.geozones__select-current p').text(geozonesContent);
      $('.geozones__select-current span').text(geozonesContent2);
      $('.geozones__select-dropdown').slideUp();
      $('.geozones__select-current').removeClass('chevron-rotate');
    });

    //Events select zones
    $('.events__select-current').click( function () {
      $('.events__select-dropdown').slideToggle();
      $('.events__select-current').toggleClass('chevron-rotate');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('.events__select-dropdown').css('display') == 'block') {
          var div = $('#events__select-click');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.events__select-dropdown').slideUp();
            $('.events__select-current').removeClass('chevron-rotate');
          }
        }
      });
    });
    $('.events__select-dropdown .accordion-input').on('click', function(){
      $('.accordion-input').not(this).prop('checked', false)
      let  eventsContent = $(this).next().find('p').html();
      let  eventsContent2 = $(this).next().find('span').html();
      $('.events__select-current p').text(eventsContent);
      $('.events__select-current span').text(eventsContent2);
      $('.events__select-dropdown').slideUp();
      $('.events__select-current').removeClass('chevron-rotate');
    });

    //geozones Groups button
    $('#zone-group-button-trigger').click( function () {
      $('#create-zone-group-button').addClass('button-active');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('#create-zone-group-button').hasClass('button-active')) {
          var div = $('#create-zone-group-button');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('#create-zone-group-button').removeClass('button-active');
          }
        }
      });
    });
    //Vehicle Groups button
    $('#create-group-button').click( function (e) {
      e.preventDefault();
      $('#create-group-button').removeClass('button-active');
      $('.modal-block').removeClass('z-index-2');
      $('.vehicle-groups').addClass('active-modal');
    });

    //Drivers Show drivers
    $(function($){
      $(document).mouseup(function (e) {
        if ($('#collapse-drivers-1').hasClass('show')) {
          var div = $('#drivers-filter');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.card-header > div').click();
          }
        }
      });
    });
    $('#collapse-drivers-1 .accordion-input').on('click', function(){
      $('.accordion-input').not(this).prop('checked', false)
      let  driversContent = $(this).next().find('p').html();
      $('.drivers .card-header .select-filter').text(driversContent);
      $('.drivers .card-header > div').click();
    });

    //Geozones Show geozones
    $(function($){
      $(document).mouseup(function (e) {
        if ($('#collapse-geozones-1').hasClass('show')) {
          var div = $('#geozones-filter');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('#geozones-filter .card-header > div').click();
          }
        }
      });
    });
    $('#collapse-geozones-1 .accordion-input').on('click', function(){
      $('.accordion-input').not(this).prop('checked', false)
      let  geozonesContent = $(this).next().find('p').html();
      $('#geozones-filter .card-header .select-filter').text(geozonesContent);
      $('#geozones-filter .card-header > div').click();
    });

    //Events Show events
    $(function($){
      $(document).mouseup(function (e) {
        if ($('#collapse-events-1').hasClass('show')) {
          var div = $('#events-filter');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('#events-filter .card-header > div').click();
          }
        }
      });
    });
    $('#collapse-events-1 .accordion-input').on('click', function(){
      $('.accordion-input').not(this).prop('checked', false)
      let  eventsFilterContent = $(this).next().find('p').html();
      $('#events-filter .card-header .select-filter').text(eventsFilterContent);
      $('#events-filter .card-header > div').click();
    });

    //Geozones group Show geozones
    $(function($){
      $(document).mouseup(function (e) {
        if ($('#collapse-geozones-group-1').hasClass('show')) {
          var div = $('#geozones-group-filter');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.geozones-group .card-header > div').click();
          }
        }
      });
    });
    $('#collapse-geozones-group-1 .accordion-input').on('click', function(){
      $('.accordion-input').not(this).prop('checked', false)
      let  geozonesGroupContent = $(this).next().find('p').html();
      $('.geozones-group .card-header .select-filter').text(geozonesGroupContent);
      $('.geozones-group .card-header > div').click();
    });

    //Geozones group Color
    $('.geozones-group__color-current').click( function () {
      $('.geozones-group__color-dropdown').slideToggle();
      $('.geozones-group__color-current').toggleClass('chevron-rotate');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('.geozones-group__color-dropdown').css('display') == 'block') {
          var div = $('#geozones-group__color-click');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.geozones-group__color-dropdown').slideUp();
            $('.geozones-group__color-current').removeClass('chevron-rotate');
          }
        }
      });
    });
    $('.geozones-group__color-dropdown .accordion-input').on('click', function(){
      $('.accordion-input').not(this).prop('checked', false)
      let  colorContent = $(this).next().find('span').attr('class')
      $('.geozones-group__color-current span').removeClass();
      $('.geozones-group__color-current span').addClass(colorContent);
      $('.geozones-group__color-dropdown').slideUp();
      $('.geozones-group__color-current').removeClass('chevron-rotate');
    });

    //Fleet Status select drivers
    $('.fleet-status__select-current').click( function () {
      $('.fleet-status__select-dropdown').slideToggle();
      $('.fleet-status__select-current').toggleClass('chevron-rotate');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('.fleet-status__select-dropdown').css('display') == 'block') {
          var div = $('#fleet-status__select-click');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.fleet-status__select-dropdown').slideUp();
            $('.fleet-status__select-current').removeClass('chevron-rotate');
          }
        }
      });
    });
    $('.fleet-status__select-dropdown .accordion-input').on('click', function(){
      $('.accordion-input').not(this).prop('checked', false)
      let  fleetStatusContent = $(this).next().find('p').html();
      let  fleetStatusContent2 = $(this).next().find('span').html();
      $('.fleet-status__select-current p').text(fleetStatusContent);
      $('.fleet-status__select-current span').text(fleetStatusContent2);
      $('.fleet-status__select-dropdown').slideUp();
      $('.fleet-status__select-current').removeClass('chevron-rotate');
    });

    //Fleet Status status buttons
    $('.fleet-status__buttons-position button').click( function () {
      $('.fleet-status__buttons-position button').removeClass('button-active');
      $(this).addClass('button-active');
      let buttonAttr = $(this).attr('data-button');
      if (buttonAttr == 'navy') {
        $('.fleet-status .modal-content__list-item').removeClass('item-hidden');
      }
      if (buttonAttr == 'green') {
        $('.fleet-status .modal-content__list-item').addClass('item-hidden');
        $('.fleet-status .modal-content__list-item[data-status="green"]').removeClass('item-hidden');
      }
      if (buttonAttr == 'blue') {
        $('.fleet-status .modal-content__list-item').addClass('item-hidden');
        $('.fleet-status .modal-content__list-item[data-status="blue"]').removeClass('item-hidden');
      }
      if (buttonAttr == 'red') {
        $('.fleet-status .modal-content__list-item').addClass('item-hidden');
        $('.fleet-status .modal-content__list-item[data-status="red"]').removeClass('item-hidden');
      }
      if (buttonAttr == 'yellow') {
        $('.fleet-status .modal-content__list-item').addClass('item-hidden');
        $('.fleet-status .modal-content__list-item[data-status="yellow"]').removeClass('item-hidden');
      }
      if (buttonAttr == 'gray') {
        $('.fleet-status .modal-content__list-item').addClass('item-hidden');
        $('.fleet-status .modal-content__list-item[data-status="gray"]').removeClass('item-hidden');
      }
    });

    //Fleet Status add parameter button
    $('#parameter-button-trigger').click( function () {
      $('#parameter-button').addClass('button-active');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('#parameter-button').hasClass('button-active')) {
          var div = $('#parameter-button');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('#parameter-button').removeClass('button-active');
          }
        }
      });
    });
    //Fleet Status add Create group button
    $('#group-button-trigger').click( function () {
      $('#create-group-button').addClass('button-active');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('#create-group-button').hasClass('button-active')) {
          var div = $('#create-group-button');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('#create-group-button').removeClass('button-active');
          }
        }
      });
    });
    //Events Pop Up
    $('#events-pop-up-button').click(function (e) {
      e.preventDefault();
      $('.events-application').addClass('application-active');
    });
    $('.events-pop-up__button-position button').click(function (e) {
      e.preventDefault();
      $('.events-application').removeClass('application-active');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('.events-application').hasClass('application-active')) {
          var div = $('#events-pop-up-click');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.events-application').removeClass('application-active')
          }
        }
      });
    });
    //Parameter Pop Up
    $('#parameter-button').click(function (e) {
      e.preventDefault();
      $('.application').addClass('application-active');
      $('#parameter-button').removeClass('button-active');
    });
    $('.pop-up-close').click(function (e) {
      e.preventDefault();
      $('.application').removeClass('application-active');
      $('.events-application').removeClass('application-active');
    });
    $('.parameter-pop-up__button-position button').click(function (e) {
      e.preventDefault();
      $('.application').removeClass('application-active');
      $('.events-application').removeClass('application-active');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('.application').hasClass('application-active')) {
          var div = $('#pop-up-click');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.application').removeClass('application-active')
          }
        }
      });
    });

    //Vehicle Groups filter
    $('.vehicle-groups .global-checkbox-label').click(function () {
      $('.vehicle-groups .allFilters').prev().prop('checked', false);
    })

    $('.vehicle-groups .allFilters').click(function (e) {
      e.preventDefault();
      // eslint-disable-next-line no-unused-vars
      let labelMas = $('.vehicle-groups .global-checkbox-label');
      if($(this).prev().is(':checked')) {
        $(this).prev().prop('checked', false);
        $(labelMas).prev().prop('checked', false);
      }
      else {
        $(labelMas).prev().prop('checked', true);
        $(this).prev().prop('checked', true);
        $(labelMas).prev().prop('checked', true);
      }
    })
    $('.vehicle-groups__list input[type=checkbox]').change(function(){
      var checkbox = $('.vehicle-groups__list input[type=checkbox]');
      var nChecked = $('.vehicle-groups__list input:checked');
      if (checkbox.length === nChecked.length+1) {
        $('.vehicle-groups .allFilters').prev().prop('checked', true);
      }
    });

    //Events pop-up filter dropdown
    $('.events-pop-up__list-item > a').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).closest('.events-pop-up__list-item').find('.events-pop-up__list-details').slideToggle();
    })

    //Events pop-up filter
    $('.events-pop-up .global-checkbox-label').click(function () {
      $('.events-pop-up .allFilters').prev().prop('checked', false);
    })
    $('.events-pop-up__list-details .global-checkbox-label').click(function () {
      $(this).closest('.events-pop-up__list-item').find('.groupFilters').prev().prop('checked', false);
    })

    $('.events-pop-up .allFilters').click(function (e) {
      e.preventDefault();
      // eslint-disable-next-line no-unused-vars
      let labelMas = $('.events-pop-up .global-checkbox-label');
      if($(this).prev().is(':checked')) {
        $(this).prev().prop('checked', false);
        $(labelMas).prev().prop('checked', false);
      }
      else {
        $(labelMas).prev().prop('checked', true);
        $(this).prev().prop('checked', true);
        $(labelMas).prev().prop('checked', true);
      }
    })

    $('.events-pop-up .groupFilters').click(function () {
      let labelGroup = $(this).closest('.events-pop-up__list-item').find('.events-pop-up__list-details-i .global-checkbox-label');
      if($(this).prev().is(':checked')) {
        $(this).prev().prop('checked', true);
        $(labelGroup).prev().prop('checked', false);
      }
      else {
        $(labelGroup).prev().prop('checked', true);
        $(this).prev().prop('checked', false);
      }
    })

    $('.events-pop-up__list .groupFilters').prev().change(function(){
      var checkbox = $('.events-pop-up__list input[type=checkbox]');
      var nChecked = $('.events-pop-up__list input:checked');
      if (checkbox.length === nChecked.length+1) {
        $('.events-pop-up .allFilters').prev().prop('checked', true);
      }
    });
    $('.events-pop-up__list-details-i > .global-checkbox-label').prev().change(function(){
     var checkbox = $(this).closest('.events-pop-up__list-details').find('input[type=checkbox]');
     var nChecked = $(this).closest('.events-pop-up__list-details').find('input:checked');
     if (checkbox.length === nChecked.length) {
       $(this).closest('.events-pop-up__list-item').find('.groupFilters').prev().prop('checked', true);
     }
   });

    //Create route Setting
    $('#settings-button-click').click(function () {
      $('#create-route__setting-box').toggleClass('active');
      $('.create-route').toggleClass('full-w');
    })
    $('#route-setting-close').click(function () {
      $('#create-route__setting-box').removeClass('active');
      $('.create-route').removeClass('full-w');
    })
    $('.cancel-setting').click(function () {
      $('#create-route__setting-box').removeClass('active');
      $('.create-route').removeClass('full-w');
    })
    if (window.matchMedia('(min-width: 1200px)').matches) {
      $(function($){
        $(document).mouseup(function (e) {
          if ($('#create-route__setting-box').hasClass('active')) {
            var div = $('#create-route__setting-box');
            var button = $('#settings-button-click')
            if (!div.is(e.target) && div.has(e.target).length === 0) {
              if (!button.is(e.target) && button.has(e.target).length === 0) {
                $('#create-route__setting-box').removeClass('active');
                $('.create-route').removeClass('full-w');
              }
            }
          }
        });
      });
    }
    //Create route point details button
    $('.point-details-button').click(function () {
      $('.create-route__point-details').removeClass('active');
      $(this).closest('.create-route__list-item').find('.create-route__point-details').toggleClass('active');
      $('.create-route').toggleClass('full-w');
    })
    $('.cancel-setting').click(function () {
      $(this).closest('.create-route__list-item').find('.create-route__point-details').removeClass('active');
      $('.create-route').removeClass('full-w');
    })
    if (window.matchMedia('(min-width: 1200px)').matches) {
      $(function($){
        $(document).mouseup(function (e) {
          if ($('.create-route__point-details').hasClass('active')) {
            var div = $('.create-route__point-details');
            var button = $('.point-details-button')
            var date = $('.datepicker')
            if (!div.is(e.target) && div.has(e.target).length === 0) {
              if (!button.is(e.target) && button.has(e.target).length === 0) {
                if (!date.is(e.target) && date.has(e.target).length === 0) {
                  $('.create-route__point-details').removeClass('active');
                  $('.create-route').removeClass('full-w');
                }
              }
            }
          }
        });
      });
    }

    //Reports links
    $('.reports__actions-pop-up-link a').click( function () {
      $('.reports__actions-pop-up-link a').not(this).closest('.reports__actions-pop-up-link').find('.reports__actions-pop-up').removeClass('active');
      $(this).closest('.reports__actions-pop-up-link').find('.reports__actions-pop-up').toggleClass('active');
    });
    $(function($){
      $(document).mouseup(function (e) {
        if ($('.reports__actions-pop-up').hasClass('active')) {
          var div = $('.reports__actions-pop-up');
          var button = $('.reports__actions-pop-up-link > a');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            if (!button.is(e.target) && button.has(e.target).length === 0) {
              $('.reports__actions-pop-up').removeClass('active');
            }
          }
        }
      });
    });
    //Reports filter
    $('.reports__list .global-checkbox-label').click(function () {
      $('.reports__list .allFilters').prev().prop('checked', false);
    })

    $('.reports__list .allFilters').click(function (e) {
      e.preventDefault();
      // eslint-disable-next-line no-unused-vars
      let labelMas = $('.reports__list .global-checkbox-label');
      if($(this).prev().is(':checked')) {
        $(this).prev().prop('checked', false);
        $(labelMas).prev().prop('checked', false);
      }
      else {
        $(labelMas).prev().prop('checked', true);
        $(this).prev().prop('checked', true);
        $(labelMas).prev().prop('checked', true);
      }
    })
    $('.reports__list input[type=checkbox]').change(function(){
      var checkbox = $('.reports__list input[type=checkbox]');
      var nChecked = $('.reports__list input:checked');
      if (checkbox.length === nChecked.length+1) {
        $('.reports__list .allFilters').prev().prop('checked', true);
      }
    });

    // Cancel button
    $('.cancel-button').click(function () {
      $(this).closest('.modal-block-2').removeClass('z-index-2');
      let thisElement = this;
      setTimeout(function() {
        $(thisElement).closest('.modal-block').removeClass('active-modal');
        $(thisElement).closest('.modal-block-2').removeClass('active-modal-2');
      }, 150);
    })

    // Map driving-status button
    $('.map__driving-status > button').click(function () {
      $('.map__driving-list').slideToggle();
      $(this).toggleClass('button-active');
    })

    //burger
    $('.header__burger').click( function () {
      $('.menu__navi').toggleClass('mobile-active');
      $('.header__burger').toggleClass('burger-active');
    });

  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};
